<template>
  <span>
    <div v-for="(contact, index) in contacts" :key="index" class="contact">
      <a v-if="contactType === 'approver'" :href="`mailto:${contact.email}`">
        <span v-if="contact.payrollNum">#{{ contact.payrollNum }}</span>
        <span>{{ contact.firstName | capitalize }} {{ contact.lastName | capitalize }}</span>
        <div v-if="contact.email" class="contact-email">
          <span><font-awesome-icon icon="envelope" /> {{ contact.email }} </span>
        </div>
        <div v-if="contact.phone1" class="contact-phone">
          <span
            ><font-awesome-icon :icon="phoneType(contact.phone1_type)" /> {{ contact.phone1 }}
          </span>
        </div>
      </a>
      <div v-else>
        <span v-if="contact.payrollNum">#{{ contact.payrollNum }}</span>
        <span>{{ contact.firstName | capitalize }} {{ contact.lastName | capitalize }}</span>
        <div v-if="contact.email" class="contact-email">
          <span><font-awesome-icon icon="envelope" /> {{ contact.email }} </span>
        </div>
        <div v-if="contact.phone1" class="contact-phone">
          <span
            ><font-awesome-icon :icon="phoneType(contact.phone1_type)" /> {{ contact.phone1 }}
          </span>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  name: 'ContactsList',
  props: {
    contacts: {
      type: Array,
      default: () => []
    },
    contactType: {
      type: String,
      default: null
    }
  },
  methods: {
    phoneType(type) {
      switch (type) {
        case 'OFFICE':
        case 'HOME':
          return 'phone-square';
        case 'MOBILE':
          return 'mobile';
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.contact {
  margin-bottom: 10px;
  padding: 15px;
  border-left: 1px solid $light-grey-1;
  &:hover {
    padding: 15px;
    cursor: pointer;
    background-color: $mid-blue;
    border-radius: 8px;
  }
  .contact-email {
    font-weight: normal;
    color: $primary-blue;
  }
  .contact-phone {
    font-weight: normal;
    color: $mid-grey-2;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
}
</style>
